import React, { useRef, useState, useEffect } from "react";
import Slider from "react-slick";
import { getImages } from "../const";

const images = [
    "pic.png",
    "pic1.jpg",
    "pic2.jpg",
    "pic3.jpg",
    "pic4.jpg",
    "pic5.jpg",
    "pic6.jpg",
];

const ProductSlider = () => {
    const [nav1, setNav1] = useState(null);
    const [nav2, setNav2] = useState(null);
    const slider1 = useRef(null);
    const slider2 = useRef(null);

    useEffect(() => {
        setNav1(slider1.current);
        setNav2(slider2.current);
    }, []);

    return (
        <div className="mxw-500">
            {/* Main Slider */}
            <Slider
                asNavFor={nav2}
                ref={slider1}
                arrows={false}
                fade={true}
            >
                {images.map((img, idx) => (
                    <div key={idx}>
                        <div className="dtl-product-box">
                            <img src={getImages(img)} alt={`Slide ${idx + 1}`} style={{ width: "100%" }} />
                        </div>
                    </div>
                ))}
            </Slider>

            {/* Thumbnail Slider */}
            <div className="px-4 mt-4">
                <Slider
                    // infinite={false}
                    asNavFor={nav1}
                    ref={slider2}
                    slidesToShow={4}
                    swipeToSlide={true}
                    focusOnSelect={true}
                    arrows={true}
                    centerMode={true}
                    centerPadding="5px"
                    className="thumb-slider product-thumb-slider"
                    responsive={[
                        {
                            breakpoint: 1200,
                            settings: {
                                slidesToShow: 3,
                            },
                        },
                        {
                            breakpoint: 992,
                            settings: {
                                slidesToShow: 4,
                            },
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 3,
                            },
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 2,
                            },
                        },
                    ]}
                >
                    {images.map((img, idx) => (
                        <div key={idx}>
                            <img
                                src={getImages(img)}
                                alt={`Thumb ${idx + 1}`}
                                style={{
                                    width: "98px",
                                    height: "98px",
                                    objectFit: "cover",
                                    cursor: "pointer",
                                    margin: '0 auto'
                                }}
                            />
                        </div>
                    ))}
                </Slider>
            </div>
        </div>
    );
};

export default ProductSlider;
